import _styled from '@emotion/styled/base';
import { Button } from '../../Button/index.js';
import { Spacing } from '../../primitives/spacing.js';
import { paddingTypes } from '../Card/constants.js';

const CardCollapsibleHeader = _styled("header", {
  target: "exvhyxb3"
})("display:grid;grid-column-gap:", ({
  padding
}) => paddingTypes[padding], ";grid-template-columns:1fr min-content;align-items:center;");
const CardCollapsibleHeading = _styled("div", {
  target: "exvhyxb2"
})("padding-top:", ({
  padding
}) => paddingTypes[padding], ";padding-bottom:", ({
  isExpanded,
  padding
}) => isExpanded ? `${Spacing.scale[2]};` : `${paddingTypes[padding]};`, ";");
const CardCollapsibleContent = _styled("div", {
  target: "exvhyxb1"
})("padding-bottom:", ({
  padding
}) => paddingTypes[padding], ";");
const CardCollapsibleButton = _styled(Button.Tertiary, {
  target: "exvhyxb0"
})({
  name: "cbh01u",
  styles: "appearance:none;border:none;background:inherit;>.selected{display:none;}&[aria-expanded='true']{>.unselected{display:none;}>.selected{display:inline-flex;}}"
} );

export { CardCollapsibleButton, CardCollapsibleContent, CardCollapsibleHeader, CardCollapsibleHeading };
